export enum SubscriptionTabs {
  PLANS = 0,
  FEATURE_PACKAGES = 1,
  DISCOUNTS = 2,
  BILLING_DETAILS = 3,
}
